<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {

  }
}
</script>

<style>
html,body {
height: 100%;
}
#app {
  height: 100%;
  background-color: #F3F5F7;
  min-width: 1400px;
  min-height: 700px;
}
  body::-webkit-scrollbar,
  div::-webkit-scrollbar,
  ul::-webkit-scrollbar{
    width:5px;
    height:5px;
    border-radius:2.5px;
  }
  body::-webkit-scrollbar-thumb,
  div::-webkit-scrollbar-thumb,
  ul::-webkit-scrollbar-thumb{
    width:5px;
    height:5px;
    border-radius:2.5px;
    background:#ddd;
  }
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}
</style>
